export type GeneratorFn<T, Ctx extends object> = (ctx: Partial<Ctx>) => T;
export type GeneratorMap<T extends object> = Partial<{
  [K in keyof T]: GeneratorFn<T[K], T>;
}>;

const FRUITS: string[] = ['blueberry', 'lychee', 'kiwi', 'mango', 'peach', 'lime', 'pomegranate', 'pineapple'];
const FIRST_NAMES: string[] = [
  'Maia',
  'Asher',
  'Olivia',
  'Atticus',
  'Amelia',
  'Jack',
  'Charlotte',
  'Theodore',
  'Isla',
  'Oliver',
  'Isabella',
  'Jasper',
  'Cora',
  'Levi',
  'Violet',
  'Arthur',
  'Mia',
  'Thomas',
  'Elizabeth',
];

const LAST_NAMES: string[] = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Miller',
  'Davis',
  'Garcia',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
];

const JOB: string[] = [
  'Software Engineer',
  'Data Scientist',
  'Product Manager',
  'Designer',
  'QA Tester',
  'DevOps Engineer',
  'System Administrator',
  'Business Analyst',
  'Project Manager',
  'Frontend Developer',
  'Backend Developer',
  'Full Stack Developer',
  'Database Administrator',
  'Network Engineer',
  'Technical Writer',
  'Support Specialist',
  'Security Analyst',
  'Mobile Developer',
  'Cloud Architect',
  'IT Consultant',
];

const ICON: string[] = [
  'person',
  'face',
  'account_circle',
  'star',
  'work',
  'verified_user',
  'group',
  'admin_panel_settings',
  'emoji_people',
  'badge',
  'fingerprint',
  'supervisor_account',
  'contact_mail',
  'contact_phone',
  'security',
  'build',
  'code',
  'computer',
  'cloud',
  'extension',
];

const ROLE: string[] = ['Admin', 'User', 'Guest'];

export class MpsGenerator {
  static number =
    (min = 0, max = 1000) =>
    () =>
      Math.floor(Math.random() * (max - min + 1)) + min;

  static string =
    (length = 8) =>
    () =>
      Math.random()
        .toString(36)
        .substring(2, 2 + length);

  static boolean = () => Math.random() > 0.5;

  static date = () => new Date();

  static constant<T>(value: T) {
    return () => value;
  }

  static pick<T>(values: readonly T[]) {
    return () => values[Math.floor(Math.random() * values.length)];
  }

  static job = (): string => {
    return JOB[Math.floor(Math.random() * JOB.length)];
  };

  static fullName = (): string => {
    const firstName = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
    const lastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
    return `${firstName} ${lastName}`;
  };

  static firstName = (): string => {
    const firstName = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
    return `${firstName}`;
  };

  static lastName = (): string => {
    const lastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
    return `${lastName}`;
  };

  static generateRandomDate = (): Date => {
    const start = new Date(2010, 0, 1);
    const end = new Date();
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  };

  static igg = (): string => {
    return (Math.random() > 0.5 ? 'L' : 'J') + Math.floor(1000000 + Math.random() * 9000000).toString();
  };

  static generateFromMap<T extends object>(map: GeneratorMap<T>): T {
    const result = {} as T;

    for (const key in map) {
      const generator = map[key];
      if (generator) {
        result[key] = generator(result);
      }
    }

    return result;
  }
}
